const state = {
  brandMenu: false,
  brand: null,
  showSideMenu: localStorage.getItem("dashboard_type") || "dashboard_menu"
};

const mutations = {
  setBrandMenu: (state, payload) => {
    state.brandMenu = payload;
  },
  setBrand: (state, payload) => {
    state.brand = payload;
  },
  setSideMenu: (state, payload) => {
    localStorage.setItem("dashboard_type", payload);
    state.showSideMenu = payload;
  }
};

const actions = {
  setBrandMenu({ commit }, data) {
    commit("setBrandMenu", data);
  },
  setBrand({ commit }, data) {
    commit("setBrand", data);
  },
  setSideMenu({ commit }, data) {
    commit("setSideMenu", data);
  }
};

const getters = {
  brandMenu: state => state.brandMenu,
  brand: state => state.brand,
  showSideMenu: state => state.showSideMenu
};

export default {
  state,
  mutations,
  actions,
  getters
};
